import { render, staticRenderFns } from "./SccjHeader.vue?vue&type=template&id=23ca4b92&scoped=true&"
import script from "./SccjHeader.vue?vue&type=script&lang=js&"
export * from "./SccjHeader.vue?vue&type=script&lang=js&"
import style0 from "./SccjHeader.vue?vue&type=style&index=0&id=23ca4b92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ca4b92",
  null
  
)

export default component.exports